var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass:
        "pb-5 py-2 sm:py-4 md:py-6 px-7 flex flex-col bg-white notesBlock",
    },
    [
      _c(
        "LoadingOverlay",
        { attrs: { loading: _vm.$apollo.loading, hasData: _vm.isDataLoaded } },
        [
          !_vm.isNotesExist
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-row justify-between mb-4" },
                    [
                      _c("CardBodyItem", {
                        staticClass: "mb-0",
                        attrs: {
                          label: "Notes",
                          additionalClass: "mb-4 notesHeading",
                          totalNumber: _vm.contractorNotes.length,
                        },
                      }),
                      _c("UiButtonMessage", {
                        attrs: {
                          label: "add black",
                          buttonClass: "customAdd",
                          buttonText: "Add notes",
                        },
                        on: { click: _vm.showModal },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "mb-2 flex warning-text mb-4 w-full" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "ml-2 mt-1 h-4 w-auto",
                          attrs: { alt: "delete notes" },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c(
                                "g",
                                { attrs: { id: "Icon / InfoCircleFilled" } },
                                [
                                  _c("path", {
                                    attrs: {
                                      id: "Vector",
                                      d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8.5 11.375C8.5 11.4438 8.44375 11.5 8.375 11.5H7.625C7.55625 11.5 7.5 11.4438 7.5 11.375V7.125C7.5 7.05625 7.55625 7 7.625 7H8.375C8.44375 7 8.5 7.05625 8.5 7.125V11.375ZM8 6C7.80374 5.99599 7.61687 5.91522 7.47948 5.775C7.3421 5.63478 7.26515 5.4463 7.26515 5.25C7.26515 5.0537 7.3421 4.86522 7.47948 4.725C7.61687 4.58478 7.80374 4.50401 8 4.5C8.19626 4.50401 8.38313 4.58478 8.52052 4.725C8.6579 4.86522 8.73485 5.0537 8.73485 5.25C8.73485 5.4463 8.6579 5.63478 8.52052 5.775C8.38313 5.91522 8.19626 5.99599 8 6Z",
                                      fill: "#070823",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c("p", { staticClass: "child ml-2" }, [
                        _vm._v(
                          " Notes are only visible to the admin & managers "
                        ),
                      ]),
                    ]
                  ),
                  _c("EmptyListPlaceholder", {
                    attrs: { subtitle: _vm.emptyListSubtitle, title: "" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "image",
                          fn: function () {
                            return [_c("EmptyListImageDocuments")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2273432899
                    ),
                  }),
                ],
                1
              )
            : _c(
                "div",
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-row justify-between mb-4" },
                    [
                      _c("CardBodyItem", {
                        staticClass: "mb-0",
                        attrs: {
                          label: "Notes",
                          additionalClass: "mb-4 notesHeading",
                          totalNumber: _vm.contractorNotes.length,
                        },
                      }),
                      _c("UiButtonMessage", {
                        attrs: {
                          label: "add black",
                          buttonClass: "customAdd",
                          buttonText: "Add notes",
                        },
                        on: { click: _vm.showModal },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "mb-2 flex warning-text mb-4 w-full" },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "ml-2 mt-1 h-4 w-auto",
                          attrs: { alt: "delete notes" },
                        },
                        [
                          _c(
                            "svg",
                            {
                              attrs: {
                                width: "16",
                                height: "16",
                                viewBox: "0 0 16 16",
                                fill: "none",
                                xmlns: "http://www.w3.org/2000/svg",
                              },
                            },
                            [
                              _c(
                                "g",
                                { attrs: { id: "Icon / InfoCircleFilled" } },
                                [
                                  _c("path", {
                                    attrs: {
                                      id: "Vector",
                                      d: "M8 1C4.13438 1 1 4.13438 1 8C1 11.8656 4.13438 15 8 15C11.8656 15 15 11.8656 15 8C15 4.13438 11.8656 1 8 1ZM8.5 11.375C8.5 11.4438 8.44375 11.5 8.375 11.5H7.625C7.55625 11.5 7.5 11.4438 7.5 11.375V7.125C7.5 7.05625 7.55625 7 7.625 7H8.375C8.44375 7 8.5 7.05625 8.5 7.125V11.375ZM8 6C7.80374 5.99599 7.61687 5.91522 7.47948 5.775C7.3421 5.63478 7.26515 5.4463 7.26515 5.25C7.26515 5.0537 7.3421 4.86522 7.47948 4.725C7.61687 4.58478 7.80374 4.50401 8 4.5C8.19626 4.50401 8.38313 4.58478 8.52052 4.725C8.6579 4.86522 8.73485 5.0537 8.73485 5.25C8.73485 5.4463 8.6579 5.63478 8.52052 5.775C8.38313 5.91522 8.19626 5.99599 8 6Z",
                                      fill: "#070823",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          ),
                        ]
                      ),
                      _c("p", { staticClass: "child ml-2" }, [
                        _vm._v(
                          " Notes are only visible to the admin & managers "
                        ),
                      ]),
                    ]
                  ),
                  _c("AddNotesToContractor", {
                    staticClass: "flex justify-end",
                    attrs: {
                      buttonSize: "xl",
                      currentUserId: _vm.currentUserId,
                      contractorUserId: _vm.contractorUserId,
                      contractorId: _vm.contractorId,
                    },
                    on: { noteWasAddedToContractor: _vm.updateNotesList },
                  }),
                  _vm._l(_vm.contractorNotes, function (contractor_note) {
                    return _c("ContractorNoteCard", {
                      key: contractor_note.id,
                      attrs: {
                        firstName: contractor_note.user.given_name,
                        lastName: contractor_note.user.family_name,
                        avatar: contractor_note.user.avatar,
                        note: contractor_note.note,
                        id: contractor_note.id,
                        currentUserId: _vm.currentUserId,
                        contractorId: _vm.contractorId,
                        contractorUserId: _vm.contractorUserId,
                        createdById: contractor_note.user.id,
                        openDate: contractor_note.created_at,
                      },
                      on: {
                        noteWasEditted: _vm.updateNotesList,
                        noteWasDeleted: _vm.updateNotesList,
                      },
                    })
                  }),
                  _vm.isDataLoaded
                    ? _c("CardPagination", {
                        attrs: { config: _vm.paginationConfig },
                        on: {
                          "update:config": function ($event) {
                            _vm.paginationConfig = $event
                          },
                        },
                      })
                    : _vm._e(),
                ],
                2
              ),
          _vm.modalShown
            ? _c("AddNotesModal", {
                attrs: {
                  currentUserId: _vm.currentUserId,
                  contractorId: _vm.contractorId,
                  contractorUserId: _vm.contractorUserId,
                  title: "Add Notes",
                },
                on: {
                  close: _vm.closeModal,
                  add: _vm.addNotesToContractors,
                  open: _vm.showModal,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }